export function formatAmountCode(
  amount: number,
  currency: string,
  locale: string,
): string {
  const hasFraction = Math.round(amount * 100) % 100 !== 0;
  const formatted = new Intl.NumberFormat(locale, {
    minimumFractionDigits: hasFraction ? 2 : 0,
    maximumFractionDigits: hasFraction ? 2 : 0,
  }).format(amount);
  return `${formatted} ${currency}`;
}

export function formatSessionCount(quantity: number, language: string): string {
  const ukrainian = language.startsWith('ua') || language.startsWith('uk');
  if (!ukrainian) {
    const word = quantity === 1 ? 'lesson' : 'lessons';
    return `${quantity} ${word}`;
  }
  const mod10 = quantity % 10;
  const mod100 = quantity % 100;
  const few = mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14);
  const one = mod10 === 1 && mod100 !== 11;
  const word = one || few ? 'заняття' : 'занять';
  return `${quantity} ${word}`;
}

export function formatMajorAmount(
  amount: number,
  currency: string,
  locale: string,
  fractionDigits: 0 | 2,
): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(amount);
}
